import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import { isClip, isUpcomingContent } from 'helpers/ContentHelper';
import { homeCarouselVideoProcessor } from 'helpers/Processor/CarouselVideoProcessor';
import ImageElement from './components/ImageElement';
import ImageOverlay from './components/ImageOverlay';
import ProgressBar from './components/ProgressBar';
import TitleLink from './components/TitleLink';
import theme from './style.css';

class CollectionTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHoverActive: false,
    };
  }

  toggleHover = val => this.setState({ isHoverActive: val });

  render() {
    const { isHoverActive } = this.state;
    const {
      breakpoint,
      favoritesManager,
      toggleUpcomingOverlay,
      item,
      itemIndex,
      onTileClick,
      scaleFromLeft,
      scaleFromRight,
      showTileMetadataOnHover,
    } = this.props;

    const {
      badge,
      hoverImage,
      image,
      link,
      name,
      networkIcon,
      originalItem,
      overlayProps,
      percentWatched,
      playButton,
      recommendationIdData,
      subtitle,
      subtitleLink,
      title,
      titleLink,
      video,
      videoType,
    } = homeCarouselVideoProcessor({ video: item });

    const { displayBrand } = item;

    const imageContainerClasses = [theme.imageContainer];
    if (scaleFromLeft) imageContainerClasses.push(theme.scaleFromLeft);
    if (scaleFromRight) imageContainerClasses.push(theme.scaleFromRight);

    const shouldInvertTitleOrder = isClip(videoType);
    const titleContainerClasses = [theme.titleContainer];
    if (shouldInvertTitleOrder) titleContainerClasses.push(theme.titleReverse);

    let imageContainerLink = link;
    let imageContainerOnClick = onTileClick;
    if (isUpcomingContent(item) && toggleUpcomingOverlay) {
      imageContainerLink = null;
      imageContainerOnClick = toggleUpcomingOverlay;
    }
    // TODO: Are all these onClickProps necessary??
    const onClickProps = {
      itemIndex,
      name,
      originalItem,
      percentWatched,
      recommendationIdData,
      titleLink,
      networkIcon,
    };

    // TODO: Move these overlay props to the overlays themselves?
    const defaultOverlayProps = {
      badge,
      displayBrand,
      showPlayButton: playButton,
      theme,
    };
    const hoverOverlayProps = {
      ...overlayProps,
      favoritesManager,
      theme,
    };

    return (
      <div className={theme.tile}>
        <Link to={imageContainerLink} onClick={() => imageContainerOnClick(onClickProps)}>
          <div
            className={classNames(imageContainerClasses)}
            onMouseEnter={() => this.toggleHover(true)}
            onMouseLeave={() => this.toggleHover(false)}
          >
            <ImageElement
              breakpoint={breakpoint}
              hoverImage={hoverImage}
              image={image}
              isHoverActive={isHoverActive}
              theme={theme}
              video={video}
            />
            <ImageOverlay
              defaultOverlayProps={defaultOverlayProps}
              hoverOverlayProps={hoverOverlayProps}
              isHoverActive={isHoverActive}
              showTileMetadataOnHover={showTileMetadataOnHover}
            />
            <ProgressBar video={item} />
          </div>
        </Link>
        <div className={classNames(titleContainerClasses)}>
          <TitleLink classes={theme.title} link={titleLink} text={title} />
          <TitleLink classes={theme.subtitle} link={subtitleLink} text={subtitle} />
        </div>
      </div>
    );
  }
}

export default CollectionTile;

CollectionTile.defaultProps = {
  favoritesManager: null,
  toggleUpcomingOverlay: null,
  item: null,
  onTileClick: () => {},
  scaleFromLeft: false,
  scaleFromRight: false,
};

CollectionTile.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  favoritesManager: PropTypes.shape({}),
  toggleUpcomingOverlay: PropTypes.func,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number.isRequired,
  onTileClick: PropTypes.func,
  scaleFromLeft: PropTypes.bool,
  scaleFromRight: PropTypes.bool,
  showTileMetadataOnHover: PropTypes.bool.isRequired,
};
